import { useState } from "react";
import ResumeModal from "./resumeModal";

export default function ResumePickerModal({ onClose, onPick, onCreateAndPick, resumes }) {
  const [showCreate, setShowCreate] = useState(false);

  if (showCreate) {
    return (
      <ResumeModal
        onClose={onClose}
        onSubmit={onCreateAndPick}
        initialResume={null}
      />
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content doc-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Select Resume</h2>

        {resumes.length === 0 ? (
          <p className="doc-empty">No resumes yet.</p>
        ) : (
          <ul className="resume-picker-list">
            {resumes.map((r) => (
              <li key={r.id} className="resume-picker-item" onClick={() => onPick(r)}>
                <span className="resume-picker-icon">📄</span>
                {r.title}
              </li>
            ))}
          </ul>
        )}

        <div className="modal-buttons">
          <button onClick={() => setShowCreate(true)}>+ Create New</button>
          <button className="secondary" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
